<div class="relative">
  <button (click)="toggleDropdown()" class="flex items-center gap-2 text-gray-700 dropdown-toggle dark:text-gray-400">
    <span class="overflow-hidden rounded-full h-9 w-9 bg-brand-100 dark:bg-brand-900 flex items-center justify-center shrink-0">
      <span class="text-sm font-semibold text-brand-600 dark:text-brand-300 select-none">
        {{ (currentUser?.name?.charAt(0) ?? '') + (currentUser?.firstSurname?.charAt(0) ?? '') | uppercase }}
      </span>
    </span>
    <span class="hidden lg:flex flex-col items-start leading-tight">
      <span class="text-sm font-medium text-gray-800 dark:text-white">{{ currentUser?.name ?? '' }} {{ currentUser?.firstSurname ?? '' }}</span>
      <span class="text-xs text-gray-400 dark:text-gray-500">{{ currentUser?.email ?? '' }}</span>
    </span>
    <svg [ngClass]="{ 'rotate-180': isOpen }"
      class="hidden lg:block stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200 shrink-0"
      width="16" height="16" viewBox="0 0 18 20" fill="none">
      <path d="M4.3125 8.65625L9 13.3437L13.6875 8.65625" stroke="currentColor" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  @if (isOpen) {
    <div class="absolute right-0 mt-3 flex w-[240px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-lg dark:border-gray-800 dark:bg-gray-900 z-50">
      <!-- Info usuario -->
      <div class="mb-2 px-3 py-2 border-b border-gray-100 dark:border-gray-800">
        <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">{{ currentUser?.name ?? '' }} {{ currentUser?.firstSurname ?? '' }}</p>
        <p class="text-xs text-gray-400 dark:text-gray-500 truncate">{{ currentUser?.email ?? '' }}</p>
      </div>

      <!-- Cerrar sesión -->
      <button (click)="logout()" [disabled]="isLoggingOut"
        class="flex w-full items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium text-error-600 transition hover:bg-error-50 dark:text-error-400 dark:hover:bg-error-900/20 disabled:opacity-60">
        @if (isLoggingOut) {
          <svg class="size-5 shrink-0 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
          </svg>
        } @else {
          <svg class="size-5 shrink-0" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497L14.3507 14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497L20.7507 5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501L14.3507 9.74501V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609L18.5007 4.74609C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609L19.2507 18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484L16.0007 12.7484C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484L5.81528 11.2484L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z"
              fill="currentColor"/>
          </svg>
        }
        {{ isLoggingOut ? 'Cerrando sesión...' : 'Cerrar sesión' }}
      </button>
    </div>
  }
</div>
